import React, { Component } from "react";
import HelperClass from "../../../config/helperClass";
import { Link } from "react-router-dom";
import DataTable from "../../../components/Tables/DataTable";
import {
  getTrunks,
  getOutboundSBCIntegration,
  createTrunk,
  saveOutboundSBCSettings,
} from "../../../config/reseller_api_calls";

const auth = new HelperClass();

class PendingApproval extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      loading: false,
      errorMessage: "",
      successMessage: "",
      trunks: [],
      sipnav_account_ips: [],
      sipnav_carrier_ips: [],
      sipnav_api_url: "",
      
      // SIPNav Configuration from DB
      sipnav_cps_limit: "10",
      sipnav_session_limit: "500",
      sipnav_no_call_progress: "12",
      sipnav_ring_time: "30",
      sipnav_enforce_cid_block: false,
      sipnav_cid_block_min_asr: "10",
      sipnav_cid_block_min_acd: "15",
      sipnav_cid_block_max_sdp: "30",
      sipnav_international_calls: false,
      sipnav_disable_rate_deck: false,
      sipnav_capacity_group: "1",
      sipnav_block_wireless: false,
      sipnav_dnis_blacklist: false,
      sipnav_block_matching_src_dst: "disabled",
      sipnav_remove_cid_name: false,
      sipnav_block_dnc: false,
      sipnav_attestation_blocking: "filtering_disabled",
      sipnav_disable_call_restrictions_cid: false,
      sipnav_disable_call_restrictions_destination: false,
      sipnav_disable_call_restrictions_ani: false,
      sipnav_ani_blacklist_global: false,
      sipnav_ani_blacklist_custom: false,
      sipnav_ani_blacklist_none: false,
      
      // DataTable
      columnServices: [],
      tableData: [],
      
      // Add Trunk Modal
      showAddModal: false,
      addModalLoading: false,
      formData: {
        client_name: "",
        trunk_name: "",
        host: "",
        channels: "",
        notes: "",
      },
      formErrors: {},
      
      // Edit Trunk Modal
      showEditModal: false,
      editTrunkData: null,
      
      // View Trunk Modal
      showViewModal: false,
      viewTrunkData: null,
      
      // SIPNav Config Modal
      showSipnavModal: false,
      sipnavModalLoading: false,
      sipnavFormData: {
        cps_limit: "10",
        session_limit: "500",
        no_call_progress: "12",
        ring_time: "30",
        account_ips: [],
        carrier_ips: [],
      },
    };
    
    // Mock client options
    this.clientOptions = [
      "Red Telecom, LLC",
      "Contact Center Solutions",
      "INCOMM",
      "Enterprise Communications",
    ];
  }

  async componentDidMount() {
    this._isMounted = true;
    if (auth.isLogin() === false) {
      auth.logout();
    }
    
    // Set columns in state
    this.setState({
      columnServices: [
        {
          name: "Trunk ID",
          options: {
            customBodyRender: (value) => (
              <span className="tb-lead">
                <a href="#">{value}</a>
              </span>
            ),
          },
        },
        { name: "Client" },
        { name: "Trunk Name" },
        {
          name: "Host",
          options: {
            customBodyRender: (value) => <span className="text-muted">{value}</span>,
          },
        },
        {
          name: "Channels",
          options: {
            customBodyRender: (value) => <span>{value?.toLocaleString()}</span>,
          },
        },
        {
          name: "Submitted",
          options: {
            customBodyRender: (value) => this.formatDate(value),
          },
        },
        {
          name: "Actions",
          options: {
            customBodyRender: (value, tableMeta) => {
              const trunk = tableMeta.rowData[6];
              if (trunk) {
                return (
                  <div className="btn-group" role="group">
                    <button
                      className="btn btn-sm btn-success"
                      onClick={() => this.handleApprove(trunk.trunk_id)}
                      disabled={this.state.loading}
                    >
                      <em className="icon ni ni-check"></em>
                      <span>Approve</span>
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => this.handleReject(trunk.trunk_id)}
                      disabled={this.state.loading}
                    >
                      <em className="icon ni ni-cross"></em>
                      <span>Reject</span>
                    </button>
                  </div>
                );
              }
              return null;
            },
          },
        },
      ],
    });
    
    this.loadTrunks();
    this.loadSipnavIPs();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  loadTrunks = async () => {
    this.setState({ loading: true, errorMessage: "" });
    try {
      const res = await getTrunks(
        auth.getAccount(),
        auth.getToken(),
        "pending"
      );
      
      if (res.data.status === 200 && this._isMounted) {
        const trunksData = res.data.data || [];
        
        // Convert to array of arrays for MUIDataTable
        const tableData = trunksData.map((trunk) => [
          trunk.trunk_id,
          trunk.client_name,
          trunk.trunk_name,
          trunk.host,
          trunk.channels,
          trunk.submitted_date,
          trunk, // Store entire trunk object
        ]);
        

        
        this.setState({
          trunks: trunksData,
          tableData: tableData,
          loading: false,
        }, () => {
        });
      } else {
        this.setState({
          errorMessage: res.data.message || "Failed to load trunks",
          loading: false,
        });
      }
    } catch (error) {
      if (this._isMounted) {
        this.setState({
          errorMessage: "An error occurred while loading trunks",
          loading: false,
        });
      }
    }
  };

  loadSipnavIPs = async () => {
    try {
      const res = await getOutboundSBCIntegration(
        auth.getAccount(),
        auth.getToken()
      );
      if (res.data.status === 200 && res.data.data && this._isMounted) {
        const data = res.data.data;
        this.setState({
          sipnav_account_ips: data.account_ips
            ? data.account_ips.split(",").map((ip) => ip.trim())
            : [],
          sipnav_carrier_ips: data.carrier_ips
            ? data.carrier_ips.split(",").map((ip) => ip.trim())
            : [],
          sipnav_api_url: data.api_url || "",
          // Load all SIPNav configuration fields
          sipnav_cps_limit: data.cps_limit || "10",
          sipnav_session_limit: data.session_limit || "500",
          sipnav_no_call_progress: data.no_call_progress || "12",
          sipnav_ring_time: data.ring_time || "30",
          sipnav_enforce_cid_block: Boolean(Number(data.enforce_cid_block)),
          sipnav_cid_block_min_asr: data.cid_block_min_asr || "10",
          sipnav_cid_block_min_acd: data.cid_block_min_acd || "15",
          sipnav_cid_block_max_sdp: data.cid_block_max_sdp || "30",
          sipnav_international_calls: Boolean(Number(data.international_calls)),
          sipnav_disable_rate_deck: Boolean(Number(data.disable_rate_deck)),
          sipnav_capacity_group: data.capacity_group || "1",
          sipnav_block_wireless: Boolean(Number(data.block_wireless)),
          sipnav_dnis_blacklist: Boolean(Number(data.dnis_blacklist)),
          sipnav_block_matching_src_dst: data.block_matching_src_dst || "disabled",
          sipnav_remove_cid_name: Boolean(Number(data.remove_cid_name)),
          sipnav_block_dnc: Boolean(Number(data.block_dnc)),
          sipnav_attestation_blocking: data.attestation_blocking || "filtering_disabled",
          sipnav_disable_call_restrictions_cid: Boolean(Number(data.disable_call_restrictions_cid)),
          sipnav_disable_call_restrictions_destination: Boolean(Number(data.disable_call_restrictions_destination)),
          sipnav_disable_call_restrictions_ani: Boolean(Number(data.disable_call_restrictions_ani)),
          sipnav_ani_blacklist_global: Boolean(Number(data.ani_blacklist_global)),
          sipnav_ani_blacklist_custom: Boolean(Number(data.ani_blacklist_custom)),
          sipnav_ani_blacklist_none: Boolean(Number(data.ani_blacklist_none)),
        });
      }
    } catch (error) {
      console.error("Error loading SIPNav configuration:", error);
    }
  };

  // handleApprove = async (trunkId) => {
  //   if (!window.confirm("Are you sure you want to approve this trunk?")) {
  //     return;
  //   }

  //   this.setState({ loading: true, errorMessage: "", successMessage: "" });
  //   try {
  //     const res = await approveTrunk(
  //       auth.getAccount(),
  //       auth.getToken(),
  //       trunkId,
  //       auth.getEmail()
  //     );

  //     if (res.data.status === 200 && this._isMounted) {
  //       this.setState({
  //         successMessage: "Trunk approved successfully!",
  //         loading: false,
  //       });
  //       // Reload trunks to get updated data
  //       this.loadTrunks();
  //     } else {
  //       this.setState({
  //         errorMessage: res.data.message || "Failed to approve trunk",
  //         loading: false,
  //       });
  //     }
  //   } catch (error) {
  //     if (this._isMounted) {
  //       this.setState({
  //         errorMessage: "An error occurred while approving trunk",
  //         loading: false,
  //       });
  //     }
  //   }
  // };

  // handleReject = async (trunkId) => {
  //   if (!window.confirm("Are you sure you want to reject this trunk?")) {
  //     return;
  //   }

  //   this.setState({ loading: true, errorMessage: "", successMessage: "" });
  //   try {
  //     // const res = await rejectTrunk(
  //     //   auth.getAccount(),
  //     //   auth.getToken(),
  //     //   trunkId,
  //     //   auth.getEmail()
  //     // );

  //     if (res.data.status === 200 && this._isMounted) {
  //       this.setState({
  //         successMessage: "Trunk rejected successfully!",
  //         loading: false,
  //       });
  //       // Reload trunks to get updated data
  //       this.loadTrunks();
  //     } else {
  //       this.setState({
  //         errorMessage: res.data.message || "Failed to reject trunk",
  //         loading: false,
  //       });
  //     }
  //   } catch (error) {
  //     if (this._isMounted) {
  //       this.setState({
  //         errorMessage: "An error occurred while rejecting trunk",
  //         loading: false,
  //       });
  //     }
  //   }
  // };

  formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // ========== Add Trunk Modal Functions ==========
  openAddModal = () => {
    this.setState({
      showAddModal: true,
      formData: {
        client_name: "",
        trunk_name: "",
        host: "",
        channels: "",
        notes: "",
      },
      formErrors: {},
      errorMessage: "",
      successMessage: "",
    });
  };

  closeAddModal = () => {
    this.setState({ showAddModal: false });
  };

  handleFormChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      formData: { ...this.state.formData, [name]: value },
      formErrors: { ...this.state.formErrors, [name]: "" },
    });
  };

  validateForm = () => {
    const { client_name, trunk_name, host, channels } = this.state.formData;
    const errors = {};

    if (!client_name.trim()) errors.client_name = "Client name is required";
    if (!trunk_name.trim()) errors.trunk_name = "Trunk name is required";
    if (!host.trim()) errors.host = "Host is required";
    if (!channels || parseInt(channels) < 1) {
      errors.channels = "Channels must be at least 1";
    }

    this.setState({ formErrors: errors });
    return Object.keys(errors).length === 0;
  };

  handleAddTrunk = async () => {
    if (!this.validateForm()) return;

    this.setState({ addModalLoading: true, errorMessage: "", successMessage: "" });
    try {
      const res = await createTrunk(
        auth.getAccount(),
        auth.getToken(),
        this.state.formData
      );

      if (res.data.status === 200 && this._isMounted) {
        this.setState({
          successMessage: "Trunk created successfully!",
          addModalLoading: false,
          showAddModal: false,
        });
        this.loadTrunks();
      } else {
        this.setState({
          errorMessage: res.data.message || "Failed to create trunk",
          addModalLoading: false,
        });
      }
    } catch (error) {
      if (this._isMounted) {
        this.setState({
          errorMessage: "An error occurred while creating trunk",
          addModalLoading: false,
        });
      }
    }
  };

  // ========== Edit Trunk Modal Functions ==========
  openEditModal = (trunk) => {
    this.setState({
      showEditModal: true,
      editTrunkData: trunk,
      formData: {
        client_name: trunk.client_name,
        trunk_name: trunk.trunk_name,
        host: trunk.host,
        channels: trunk.channels.toString(),
        notes: trunk.notes || "",
      },
      formErrors: {},
      errorMessage: "",
      successMessage: "",
    });
  };

  closeEditModal = () => {
    this.setState({ showEditModal: false, editTrunkData: null });
  };

  // handleEditTrunk = async () => {
  //   if (!this.validateForm()) return;

  //   this.setState({ addModalLoading: true, errorMessage: "", successMessage: "" });
  //   try {
  //     const res = await updateTrunk(
  //       auth.getAccount(),
  //       auth.getToken(),
  //       this.state.editTrunkData.trunk_id,
  //       this.state.formData
  //     );

  //     if (res.data.status === 200 && this._isMounted) {
  //       this.setState({
  //         successMessage: "Trunk updated successfully!",
  //         addModalLoading: false,
  //         showEditModal: false,
  //         editTrunkData: null,
  //       });
  //       this.loadTrunks();
  //     } else {
  //       this.setState({
  //         errorMessage: res.data.message || "Failed to update trunk",
  //         addModalLoading: false,
  //       });
  //     }
  //   } catch (error) {
  //     if (this._isMounted) {
  //       this.setState({
  //         errorMessage: "An error occurred while updating trunk",
  //         addModalLoading: false,
  //       });
  //     }
  //   }
  // };

  // ========== View Trunk Modal Functions ==========
  openViewModal = (trunk) => {
    this.setState({
      showViewModal: true,
      viewTrunkData: trunk,
    });
  };

  closeViewModal = () => {
    this.setState({ showViewModal: false, viewTrunkData: null });
  };

  // ========== SIPNav Config Modal Functions ==========
  openSipnavConfigModal = () => {
    // Populate modal with existing configuration from database
    this.setState({
      showSipnavModal: true,
      sipnavFormData: {
        cps_limit: this.state.sipnav_cps_limit,
        session_limit: this.state.sipnav_session_limit,
        no_call_progress: this.state.sipnav_no_call_progress,
        ring_time: this.state.sipnav_ring_time,
        enforce_cid_block: this.state.sipnav_enforce_cid_block,
        cid_block_min_asr: this.state.sipnav_cid_block_min_asr,
        cid_block_min_acd: this.state.sipnav_cid_block_min_acd,
        cid_block_max_sdp: this.state.sipnav_cid_block_max_sdp,
        international_calls: this.state.sipnav_international_calls,
        disable_rate_deck: this.state.sipnav_disable_rate_deck,
        capacity_group: this.state.sipnav_capacity_group,
        block_wireless: this.state.sipnav_block_wireless,
        dnis_blacklist: this.state.sipnav_dnis_blacklist,
        block_matching_src_dst: this.state.sipnav_block_matching_src_dst,
        remove_cid_name: this.state.sipnav_remove_cid_name,
        block_dnc: this.state.sipnav_block_dnc,
        attestation_blocking: this.state.sipnav_attestation_blocking,
        disable_call_restrictions_cid: this.state.sipnav_disable_call_restrictions_cid,
        disable_call_restrictions_destination: this.state.sipnav_disable_call_restrictions_destination,
        disable_call_restrictions_ani: this.state.sipnav_disable_call_restrictions_ani,
        ani_blacklist_global: this.state.sipnav_ani_blacklist_global,
        ani_blacklist_custom: this.state.sipnav_ani_blacklist_custom,
        ani_blacklist_none: this.state.sipnav_ani_blacklist_none,
        account_ips: [...this.state.sipnav_account_ips],
        carrier_ips: [...this.state.sipnav_carrier_ips],
      },
      errorMessage: "",
      successMessage: "",
    });
  };

  closeSipnavConfigModal = () => {
    this.setState({ showSipnavModal: false });
  };

  handleSipnavFormChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      sipnavFormData: { ...this.state.sipnavFormData, [name]: value },
    });
  };

  handleIPChange = (type, index, value) => {
    const ipArray = [...this.state.sipnavFormData[type]];
    ipArray[index] = value;
    this.setState({
      sipnavFormData: { ...this.state.sipnavFormData, [type]: ipArray },
    });
  };

  addIP = (type) => {
    const ipArray = [...this.state.sipnavFormData[type], ""];
    this.setState({
      sipnavFormData: { ...this.state.sipnavFormData, [type]: ipArray },
    });
  };

  removeIP = (type, index) => {
    const ipArray = this.state.sipnavFormData[type].filter((_, i) => i !== index);
    this.setState({
      sipnavFormData: { ...this.state.sipnavFormData, [type]: ipArray },
    });
  };

  handleSaveSipnavConfig = async () => {
    const formData = this.state.sipnavFormData;
    const { 
      cps_limit, 
      session_limit, 
      no_call_progress, 
      ring_time, 
      account_ips, 
      carrier_ips,
      enforce_cid_block,
      cid_block_min_asr,
      cid_block_min_acd,
      cid_block_max_sdp,
      international_calls,
      disable_rate_deck,
      capacity_group,
      block_wireless,
      dnis_blacklist,
      remove_cid_name,
      block_dnc,
      block_matching_src_dst,
      attestation_blocking,
      disable_call_restrictions_cid,
      disable_call_restrictions_destination,
      disable_call_restrictions_ani,
      ani_blacklist_global,
      ani_blacklist_custom,
      ani_blacklist_none,
    } = formData;

    // Validation
    const validAccountIps = account_ips.filter((ip) => ip.trim());
    const validCarrierIps = carrier_ips.filter((ip) => ip.trim());

    if (validAccountIps.length === 0) {
      this.setState({ errorMessage: "At least one Account IP is required" });
      return;
    }

    if (validCarrierIps.length === 0) {
      this.setState({ errorMessage: "At least one Carrier IP is required" });
      return;
    }

    // Build disable_call_restrictions string
    let disableCallRestrictions = [];
    if (disable_call_restrictions_cid) disableCallRestrictions.push("cid");
    if (disable_call_restrictions_destination) disableCallRestrictions.push("destination");
    if (disable_call_restrictions_ani) disableCallRestrictions.push("ani");
    const disableCallRestrictionsStr = disableCallRestrictions.join(",");

    // Build ani_blacklist string
    let aniBlacklist = "none";
    if (ani_blacklist_global) aniBlacklist = "global";
    else if (ani_blacklist_custom) aniBlacklist = "custom";

    this.setState({ sipnavModalLoading: true, errorMessage: "", successMessage: "" });
    try {
      const res = await saveOutboundSBCSettings(
        auth.getAccount(),
        auth.getToken(),
        cps_limit || "10",
        session_limit || "500",
        no_call_progress || "12",
        ring_time || "30",
        enforce_cid_block || false,
        cid_block_min_asr || "10",
        cid_block_min_acd || "15",
        cid_block_max_sdp || "30",
        international_calls || false,
        disable_rate_deck || false,
        capacity_group || "1",
        block_wireless || false,
        dnis_blacklist || false,
        remove_cid_name || false,
        block_dnc || false,
        block_matching_src_dst || "disabled",
        attestation_blocking || "filtering_disabled",
        disableCallRestrictionsStr,
        aniBlacklist,
        validAccountIps.join(","),
        validCarrierIps.join(",")
      );

      if (res.data.status === 200 && this._isMounted) {
        this.setState({
          successMessage: "SIPNav configuration updated successfully!",
          sipnavModalLoading: false,
          showSipnavModal: false,
        });
        this.loadSipnavIPs();
      } else {
        this.setState({
          errorMessage: res.data.message || "Failed to update configuration",
          sipnavModalLoading: false,
        });
      }
    } catch (error) {
      if (this._isMounted) {
        this.setState({
          errorMessage: "An error occurred while updating configuration",
          sipnavModalLoading: false,
        });
      }
    }
  };

  render() {
    const {
      trunks,
      loading,
      errorMessage,
      successMessage,
      sipnav_account_ips,
      sipnav_carrier_ips,
      tableData,
      columnServices,
    } = this.state;

    const activeTrunks = trunks.filter((t) => t.status === "active").length;
    const pendingTrunks = trunks.filter((t) => t.status === "pending").length;
    const totalChannels = trunks.reduce((sum, t) => sum + t.channels, 0);
    const totalClients = new Set(trunks.map((t) => t.client_name)).size;


    return (
      <>
      <div className="nk-content">
        <div className="container-fluid">
          <div className="nk-content-inner">
            <div className="nk-content-body">
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      SIP Trunk Management
                    </h3>
                    <div className="nk-block-des text-soft">
                      <p>
                        Review and approve pending SIP trunk configurations
                      </p>
                    </div>
                  </div>
                  <div className="nk-block-head-content">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="pageMenu"
                      >
                        <em className="icon ni ni-menu-alt-r"></em>
                      </a>
                      <div
                        className="toggle-expand-content"
                        data-content="pageMenu"
                      >
                        <ul className="nk-block-tools g-3">
                          <li>
                            <button
                              className="btn btn-primary"
                              onClick={this.openAddModal}
                            >
                              <em className="icon ni ni-plus"></em>
                              <span>Add Trunk</span>
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Stats Cards */}
              <div className="nk-block">
                <div className="row g-gs">
                  {loading && tableData.length === 0 ? (
                    // Loading Skeleton for Stats Cards
                    <>
                      {[1, 2, 3, 4].map((i) => (
                        <div key={i} className="col-lg-3 col-md-6">
                          <div className="card card-bordered">
                            <div className="card-inner">
                              <div className="card-title-group align-center">
                                <div className="card-title">
                                  <div className="skeleton-text" style={{ width: "100px", height: "14px" }}></div>
                                </div>
                                <div className="card-tools">
                                  <div className="icon-circle icon-circle-md skeleton-circle"></div>
                                </div>
                              </div>
                              <div className="align-end flex-sm-wrap flex-md-nowrap mt-3">
                                <div className="nk-sale-data">
                                  <div className="skeleton-text" style={{ width: "80px", height: "32px" }}></div>
                                </div>
                              </div>
                              <div className="mt-2">
                                <div className="skeleton-text" style={{ width: "120px", height: "12px" }}></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    // Actual Stats Cards
                    <>
                      <div className="col-lg-3 col-md-6">
                        <div className="card card-bordered">
                          <div className="card-inner">
                            <div className="card-title-group align-center">
                              <div className="card-title">
                                <h6 className="subtitle">Active Trunks</h6>
                              </div>
                              <div className="card-tools">
                                <div className="icon-circle icon-circle-md bg-success-dim">
                                  <em className="icon ni ni-server text-success"></em>
                                </div>
                              </div>
                            </div>
                            <div className="align-end flex-sm-wrap flex-md-nowrap">
                              <div className="nk-sale-data">
                                <span className="amount" style={{ fontSize: "2rem", fontWeight: "700" }}>{activeTrunks}</span>
                              </div>
                            </div>
                            <div className="">
                              <small className="text-soft">Healthy connections</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="card card-bordered">
                          <div className="card-inner">
                            <div className="card-title-group align-center">
                              <div className="card-title">
                                <h6 className="subtitle">PENDING APPROVAL</h6>
                              </div>
                              <div className="card-tools">
                                <div className="icon-circle icon-circle-md bg-warning-dim">
                                  <em className="icon ni ni-clock text-warning"></em>
                                </div>
                              </div>
                            </div>
                            <div className="align-end flex-sm-wrap flex-md-nowrap">
                              <div className="nk-sale-data">
                                <span className="amount" style={{ fontSize: "2rem", fontWeight: "700" }}>{pendingTrunks}</span>
                              </div>
                            </div>
                            <div className="">
                              <small className="text-soft">Awaiting review</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="card card-bordered">
                          <div className="card-inner">
                            <div className="card-title-group align-center">
                              <div className="card-title">
                                <h6 className="subtitle">Total Channels</h6>
                              </div>
                              <div className="card-tools">
                                <div className="icon-circle icon-circle-md bg-info-dim">
                                  <em className="icon ni ni-activity-round text-info"></em>
                                </div>
                              </div>
                            </div>
                            <div className="align-end flex-sm-wrap flex-md-nowrap">
                              <div className="nk-sale-data">
                                <span className="amount" style={{ fontSize: "2rem", fontWeight: "700" }}>
                                  {totalChannels.toLocaleString()}
                                </span>
                              </div>
                            </div>
                            <div className="">
                              <small className="text-soft">Across all trunks</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6">
                        <div className="card card-bordered">
                          <div className="card-inner">
                            <div className="card-title-group align-center">
                              <div className="card-title">
                                <h6 className="subtitle">Clients with Trunk</h6>
                              </div>
                              <div className="card-tools">
                                <div className="icon-circle icon-circle-md bg-primary-dim">
                                  <em className="icon ni ni-users text-primary"></em>
                                </div>
                              </div>
                            </div>
                            <div className="align-end flex-sm-wrap flex-md-nowrap">
                              <div className="nk-sale-data">
                                <span className="amount" style={{ fontSize: "2rem", fontWeight: "700" }}>{totalClients}</span>
                              </div>
                            </div>
                            <div className="">
                              <small className="text-soft">Of 24 total clients</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* Error/Success Messages */}
              {errorMessage && (
                <div className="nk-block">
                  <div className="alert alert-danger alert-icon">
                    <em className="icon ni ni-cross-circle"></em>
                    {errorMessage}
                  </div>
                </div>
              )}
              {successMessage && (
                <div className="nk-block">
                  <div className="alert alert-success alert-icon">
                    <em className="icon ni ni-check-circle"></em>
                    {successMessage}
                  </div>
                </div>
              )}

              {/* Warning Banner */}
              {trunks.length > 0 && (
                <div className="nk-block">
                  <div className="alert alert-warning alert-icon">
                    <em className="icon ni ni-alert-circle"></em>
                    <strong>{trunks.length} SIP trunk{trunks.length > 1 ? 's are' : ' is'}</strong>{" "}
                    pending approval. Review and approve to activate client trunk
                    connections.
                  </div>
                </div>
              )}

              {/* Main Content */}
              <div className="nk-block">
                <div className="card card-bordered card-stretch">
                  <div className="card-inner-group">
                    {/* Tabs */}
                    <div className="position-relative card-tools-toggle">
                        <div className="p-3">
                          <ul className="nav nav-tabs">
                            <li className="nav-item">
                              <Link className="nav-link" to="/all_trunks">
                                <span>All Trunks</span>
                              </Link>
                            </li>
                            <li className="nav-item">
                              <a className="nav-link active" href="#">
                                <span>Pending Approval</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                    </div>

                    {/* Table */}
                    <div className="card-inner p-0">
                      {loading && tableData.length === 0 ? (
                        // Loading Skeleton for Table
                        <div className="nk-tb-list">
                          {/* Table Header Skeleton */}
                          <div className="nk-tb-item nk-tb-head">
                            {[1, 2, 3, 4, 5, 6, 7].map((i) => (
                              <div key={i} className="nk-tb-col">
                                <div className="skeleton-text" style={{ width: "80px", height: "12px" }}></div>
                              </div>
                            ))}
                          </div>
                          {/* Table Rows Skeleton */}
                          {[1, 2, 3, 4, 5].map((row) => (
                            <div key={row} className="nk-tb-item">
                              {[1, 2, 3, 4, 5, 6, 7].map((col) => (
                                <div key={col} className="nk-tb-col">
                                  <div className="skeleton-text" style={{ 
                                    width: col === 1 ? "60px" : col === 2 || col === 3 ? "100px" : "70px", 
                                    height: "14px" 
                                  }}></div>
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                      ) : columnServices.length > 0 ? (
                        <DataTable
                          tableData={tableData}
                          columns={columnServices}
                          log_type="trunks"
                          accountnoFromParams={auth.getAccount()}
                          from="trunks"
                        />
                      ) : (
                        <div className="text-center p-5">
                          <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Loading columns...</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* SIPNav IP Assignments Section */}
              <div className="nk-block">
                <div className="card card-bordered">
                  <div className="card-inner">
                    <div className="card-title-group align-start mb-3">
                      <div className="card-title">
                        <h6 className="title">SIPNav IP Assignments</h6>
                        <p className="text-soft">
                          IPs shown to clients based on trunk type after submission
                        </p>
                      </div>
                      <div className="card-tools">
                        <button 
                          className="btn btn-primary btn-sm"
                          onClick={this.openSipnavConfigModal}
                        >
                          <em className="icon ni ni-setting"></em>
                          <span>Configure IPs</span>
                        </button>
                      </div>
                    </div>

                    <div className="row g-4">
                      {/* Remediation Trunks */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">
                            <strong>REMEDIATION TRUNKS</strong>
                          </label>
                          <div className="form-control-wrap">
                            <div className="p-3 border rounded">
                              <p className="small text-muted mb-2">
                                Uses VoiceAlerts IP Address
                              </p>
                              {sipnav_account_ips.length > 0 ? (
                                <div className="d-flex flex-wrap " style={{ gap: "0.5rem" }}>
                                  {sipnav_account_ips.map((ip, index) => (
                                    <span
                                      key={index}
                                      className="badge badge-lg badge-dim badge-primary"
                                      style={{
                                        fontSize: "0.875rem",
                                        padding: "0.5rem 0.75rem",
                                      }}
                                    >
                                      {ip}
                                    </span>
                                  ))}
                                </div>
                              ) : (
                                <p className="text-muted">No IPs configured</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Origination / Termination Trunks */}
                      <div className="col-md-6">
                        <div className="form-group">
                          <label className="form-label">
                            <strong>ORIGINATION / TERMINATION TRUNKS</strong>
                          </label>
                          <div className="form-control-wrap">
                            <div className="p-3 border rounded">
                              <p className="small text-muted mb-2">
                                Uses SIPNav Account IPs (3 IPs)
                              </p>
                              {sipnav_carrier_ips.length > 0 ? (
                                <div className="d-flex flex-wrap " style={{ gap: "0.5rem" }}>
                                  {sipnav_carrier_ips.map((ip, index) => (
                                    <span
                                      key={index}
                                      className="badge badge-lg badge-dim badge-success"
                                      style={{
                                        fontSize: "0.875rem",
                                        padding: "0.5rem 0.75rem",
                                      }}
                                    >
                                      {ip}
                                    </span>
                                  ))}
                                </div>
                              ) : (
                                <p className="text-muted">No IPs configured</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add/Edit Trunk Modal */}
      {(this.state.showAddModal || this.state.showEditModal) && (
        <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {this.state.showEditModal ? "Edit Trunk" : "Add New Trunk"}
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.state.showEditModal ? this.closeEditModal : this.closeAddModal}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="form-group">
                    <label className="form-label">Client Name *</label>
                    <select
                      className={`form-control ${this.state.formErrors.client_name ? "is-invalid" : ""}`}
                      name="client_name"
                      value={this.state.formData.client_name}
                      onChange={this.handleFormChange}
                    >
                      <option value="">Select Client</option>
                      {this.clientOptions.map((client) => (
                        <option key={client} value={client}>
                          {client}
                        </option>
                      ))}
                    </select>
                    {this.state.formErrors.client_name && (
                      <div className="invalid-feedback">{this.state.formErrors.client_name}</div>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="form-label">Trunk Name *</label>
                    <input
                      type="text"
                      className={`form-control ${this.state.formErrors.trunk_name ? "is-invalid" : ""}`}
                      name="trunk_name"
                      placeholder="e.g., Primary-SIP-Trunk"
                      value={this.state.formData.trunk_name}
                      onChange={this.handleFormChange}
                    />
                    {this.state.formErrors.trunk_name && (
                      <div className="invalid-feedback">{this.state.formErrors.trunk_name}</div>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="form-label">Host *</label>
                    <input
                      type="text"
                      className={`form-control ${this.state.formErrors.host ? "is-invalid" : ""}`}
                      name="host"
                      placeholder="e.g., sip.example.com"
                      value={this.state.formData.host}
                      onChange={this.handleFormChange}
                    />
                    {this.state.formErrors.host && (
                      <div className="invalid-feedback">{this.state.formErrors.host}</div>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="form-label">Channels *</label>
                    <input
                      type="number"
                      className={`form-control ${this.state.formErrors.channels ? "is-invalid" : ""}`}
                      name="channels"
                      placeholder="e.g., 100"
                      min="1"
                      value={this.state.formData.channels}
                      onChange={this.handleFormChange}
                    />
                    {this.state.formErrors.channels && (
                      <div className="invalid-feedback">{this.state.formErrors.channels}</div>
                    )}
                  </div>

                  <div className="form-group">
                    <label className="form-label">Notes</label>
                    <textarea
                      className="form-control"
                      name="notes"
                      rows="3"
                      placeholder="Additional notes or comments"
                      value={this.state.formData.notes}
                      onChange={this.handleFormChange}
                    />
                  </div>
                </form>
              </div>
              <div className="modal-footer bg-light">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={this.state.showEditModal ? this.closeEditModal : this.closeAddModal}
                  disabled={this.state.addModalLoading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.state.showEditModal ? this.handleEditTrunk : this.handleAddTrunk}
                  disabled={this.state.addModalLoading}
                >
                  {this.state.addModalLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm mr-2" />
                      Saving...
                    </>
                  ) : this.state.showEditModal ? (
                    "Update Trunk"
                  ) : (
                    "Create Trunk"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* View Trunk Modal */}
      {this.state.showViewModal && this.state.viewTrunkData && (
        <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Trunk Details</h5>
                <button type="button" className="close" onClick={this.closeViewModal}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row gy-4">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label text-soft">Trunk ID</label>
                      <p className="form-control-plaintext font-weight-bold">
                        {this.state.viewTrunkData.trunk_id}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label text-soft">Client</label>
                      <p className="form-control-plaintext">
                        {this.state.viewTrunkData.client_name}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label text-soft">Trunk Name</label>
                      <p className="form-control-plaintext">
                        {this.state.viewTrunkData.trunk_name}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label text-soft">Host</label>
                      <p className="form-control-plaintext">
                        {this.state.viewTrunkData.host}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label text-soft">Channels</label>
                      <p className="form-control-plaintext">
                        {this.state.viewTrunkData.channels.toLocaleString()}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label text-soft">Submitted Date</label>
                      <p className="form-control-plaintext">
                        {this.formatDate(this.state.viewTrunkData.submitted_date)}
                      </p>
                    </div>
                  </div>
                  {this.state.viewTrunkData.notes && (
                    <div className="col-12">
                      <div className="form-group">
                        <label className="form-label text-soft">Notes</label>
                        <p className="form-control-plaintext">
                          {this.state.viewTrunkData.notes}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer bg-light">
                <button type="button" className="btn btn-secondary" onClick={this.closeViewModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* SIPNav Configuration Modal */}
      {this.state.showSipnavModal && (
        <div className="modal fade show" style={{ display: "block", overflow: "auto" }} tabIndex="-1">
          <div className="modal-dialog modal-lg" role="document" style={{ maxWidth: "900px", margin: "1.75rem auto" }}>
            <div className="modal-content">
              {/* Modal Header */}
              <div className="modal-header" style={{ borderBottom: "1px solid #e5e9f2", padding: "14px 20px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: 10,
                      background: "#f0f3ff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <em className="icon ni ni-setting" style={{ color: "#6576ff", fontSize: 20 }}></em>
                  </div>
                  <div>
                    <div style={{ color: "#364a63", fontWeight: 600, fontSize: "1rem" }}>
                      SIPNav IP Configuration
                    </div>
                    <div style={{ color: "#8094ae", fontSize: "0.8rem" }}>
                      Configure IP addresses and SIP settings
                    </div>
                  </div>
                </div>
                <button type="button" className="close" onClick={this.closeSipnavConfigModal}>
                  <span>&times;</span>
                </button>
              </div>

              {/* Modal Body */}
              <div className="modal-body" style={{ padding: "20px", maxHeight: "calc(100vh - 200px)", overflowY: "auto" }}>
                {this.state.errorMessage && (
                  <div className="alert alert-danger mb-3">
                    <h6>Error</h6>
                    <p>{this.state.errorMessage}</p>
                  </div>
                )}

                {/* Core Settings Header */}
                <div style={{ 
                  marginBottom: 16, 
                  paddingBottom: 8, 
                  borderBottom: "1px solid #e5e9f2" 
                }}>
                  <div style={{ color: "#364a63", fontWeight: 600, fontSize: "0.9rem" }}>
                    Core Settings
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">CPS Limit</label>
                      <input
                        type="number"
                        className="form-control"
                        name="cps_limit"
                        placeholder="e.g. 10"
                        value={this.state.sipnavFormData.cps_limit}
                        onChange={this.handleSipnavFormChange}
                        min="0"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Session Limit</label>
                      <input
                        type="number"
                        className="form-control"
                        name="session_limit"
                        placeholder="e.g. 500"
                        value={this.state.sipnavFormData.session_limit}
                        onChange={this.handleSipnavFormChange}
                        min="0"
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">No Call Progress (sec)</label>
                      <input
                        type="number"
                        className="form-control"
                        name="no_call_progress"
                        placeholder="e.g. 12"
                        value={this.state.sipnavFormData.no_call_progress}
                        onChange={this.handleSipnavFormChange}
                        min="0"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="form-label">Ring Time (sec)</label>
                      <input
                        type="number"
                        className="form-control"
                        name="ring_time"
                        placeholder="e.g. 30"
                        value={this.state.sipnavFormData.ring_time}
                        onChange={this.handleSipnavFormChange}
                        min="0"
                      />
                    </div>
                  </div>
                </div>

                {/* Advanced Settings Header */}
                <div style={{ 
                  marginTop: 24, 
                  marginBottom: 16, 
                  paddingBottom: 8, 
                  borderBottom: "1px solid #e5e9f2" 
                }}>
                  <div style={{ color: "#364a63", fontWeight: 600, fontSize: "0.9rem" }}>
                    Advanced Settings
                  </div>
                </div>

                {/* Enforce CID Block */}
                <div className="row">
                  <div className="col-6" style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <div className="custom-control custom-switch">
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id="enforce_cid_block"
                        checked={this.state.sipnavFormData.enforce_cid_block || false}
                        onChange={(e) => this.setState({
                          sipnavFormData: { ...this.state.sipnavFormData, enforce_cid_block: e.target.checked }
                        })}
                      />
                      <label className="custom-control-label" htmlFor="enforce_cid_block"></label>
                    </div>
                    <label htmlFor="enforce_cid_block" style={{ color: "#364a63", fontWeight: 500, marginBottom: 0, cursor: "pointer" }}>
                      Enforce CID Block
                    </label>
                  </div>
                  <div className="col-6">
                    <div className="mt-2 mb-2">
                      <label className="form-label">CID Block Min ASR</label>
                      <input
                        type="number"
                        className="form-control"
                        name="cid_block_min_asr"
                        placeholder="e.g. 10"
                        value={this.state.sipnavFormData.cid_block_min_asr || ""}
                        onChange={this.handleSipnavFormChange}
                        min="0"
                      />
                    </div>
                  </div>
                </div>

                {/* CID Block Settings */}
                <div className="row">
                  <div className="col-6">
                    <div className="mt-2 mb-2">
                      <label className="form-label">CID Block Min ACD</label>
                      <input
                        type="number"
                        className="form-control"
                        name="cid_block_min_acd"
                        placeholder="e.g. 15"
                        value={this.state.sipnavFormData.cid_block_min_acd || ""}
                        onChange={this.handleSipnavFormChange}
                        min="0"
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="mt-2 mb-2">
                      <label className="form-label">CID Block Max SDP</label>
                      <input
                        type="number"
                        className="form-control"
                        name="cid_block_max_sdp"
                        placeholder="e.g. 30"
                        value={this.state.sipnavFormData.cid_block_max_sdp || ""}
                        onChange={this.handleSipnavFormChange}
                        min="0"
                      />
                    </div>
                  </div>
                </div>

                {/* Toggle Settings Row 1 */}
                <div className="row">
                  <div className="col-6">
                    <div className="mt-2 mb-2">
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <div className="custom-control custom-switch">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="international_calls"
                            checked={this.state.sipnavFormData.international_calls || false}
                            onChange={(e) => this.setState({
                              sipnavFormData: { ...this.state.sipnavFormData, international_calls: e.target.checked }
                            })}
                          />
                          <label className="custom-control-label" htmlFor="international_calls"></label>
                        </div>
                        <label htmlFor="international_calls" style={{ color: "#364a63", fontWeight: 500, marginBottom: 0, cursor: "pointer" }}>
                          International Calls
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="mt-2 mb-2">
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <div className="custom-control custom-switch">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="disable_rate_deck"
                            checked={this.state.sipnavFormData.disable_rate_deck || false}
                            onChange={(e) => this.setState({
                              sipnavFormData: { ...this.state.sipnavFormData, disable_rate_deck: e.target.checked }
                            })}
                          />
                          <label className="custom-control-label" htmlFor="disable_rate_deck"></label>
                        </div>
                        <label htmlFor="disable_rate_deck" style={{ color: "#364a63", fontWeight: 500, marginBottom: 0, cursor: "pointer" }}>
                          Disable Rate Deck Validation
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Capacity Group */}
                <div className="row">
                  <div className="col-6">
                    <div className="mt-2 mb-2">
                      <label className="form-label">Capacity Group</label>
                      <input
                        type="number"
                        className="form-control"
                        name="capacity_group"
                        placeholder="e.g. 1"
                        value={this.state.sipnavFormData.capacity_group || ""}
                        onChange={this.handleSipnavFormChange}
                        min="0"
                      />
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="mt-2 mb-2">
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <div className="custom-control custom-switch">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="block_wireless"
                            checked={this.state.sipnavFormData.block_wireless || false}
                            onChange={(e) => this.setState({
                              sipnavFormData: { ...this.state.sipnavFormData, block_wireless: e.target.checked }
                            })}
                          />
                          <label className="custom-control-label" htmlFor="block_wireless"></label>
                        </div>
                        <label htmlFor="block_wireless" style={{ color: "#364a63", fontWeight: 500, marginBottom: 0, cursor: "pointer" }}>
                          Block Wireless
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Toggle Settings Row 2 */}
                <div className="row">
                  <div className="col-6">
                    <div className="mt-2 mb-2">
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <div className="custom-control custom-switch">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="dnis_blacklist"
                            checked={this.state.sipnavFormData.dnis_blacklist || false}
                            onChange={(e) => this.setState({
                              sipnavFormData: { ...this.state.sipnavFormData, dnis_blacklist: e.target.checked }
                            })}
                          />
                          <label className="custom-control-label" htmlFor="dnis_blacklist"></label>
                        </div>
                        <label htmlFor="dnis_blacklist" style={{ color: "#364a63", fontWeight: 500, marginBottom: 0, cursor: "pointer" }}>
                          DNIS Blacklist
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group mt-2">
                      <label className="form-label">Block Matching Src/Dst</label>
                      <select
                        className="form-control"
                        name="block_matching_src_dst"
                        value={this.state.sipnavFormData.block_matching_src_dst || "disabled"}
                        onChange={this.handleSipnavFormChange}
                      >
                        <option value="disabled">Disabled</option>
                        <option value="enabled">Enabled</option>
                        <option value="log_only">Log Only</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Toggle Settings Row 3 */}
                <div className="row">
                  <div className="col-6">
                    <div className="mt-2 mb-2">
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <div className="custom-control custom-switch">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="remove_cid_name"
                            checked={this.state.sipnavFormData.remove_cid_name || false}
                            onChange={(e) => this.setState({
                              sipnavFormData: { ...this.state.sipnavFormData, remove_cid_name: e.target.checked }
                            })}
                          />
                          <label className="custom-control-label" htmlFor="remove_cid_name"></label>
                        </div>
                        <label htmlFor="remove_cid_name" style={{ color: "#364a63", fontWeight: 500, marginBottom: 0, cursor: "pointer" }}>
                          Remove CID Name
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="mt-2 mb-2">
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <div className="custom-control custom-switch">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="block_dnc"
                            checked={this.state.sipnavFormData.block_dnc || false}
                            onChange={(e) => this.setState({
                              sipnavFormData: { ...this.state.sipnavFormData, block_dnc: e.target.checked }
                            })}
                          />
                          <label className="custom-control-label" htmlFor="block_dnc"></label>
                        </div>
                        <label htmlFor="block_dnc" style={{ color: "#364a63", fontWeight: 500, marginBottom: 0, cursor: "pointer" }}>
                          Block DNC
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Attestation Blocking Dropdown */}
                <div className="mt-2 mb-2">
                  <label className="form-label">Attestation Blocking</label>
                  <select
                    className="form-control"
                    name="attestation_blocking"
                    value={this.state.sipnavFormData.attestation_blocking || "filtering_disabled"}
                    onChange={this.handleSipnavFormChange}
                  >
                    <option value="filtering_disabled">Filtering Disabled</option>
                    <option value="block_non_attested">Block Non-Attested</option>
                    <option value="block_a_attested">Block A-Attested</option>
                  </select>
                </div>

                {/* Disable Call Restrictions + ANI Blacklist side by side */}
                <div className="row mt-3">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label style={{ color: "#364a63", fontWeight: 500, display: "block", marginBottom: 8 }}>
                        Disable Call Restrictions
                      </label>
                      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", border: "1px solid #e5e9f2", borderRadius: 6, padding: "10px 14px" }}>
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="disable_call_restrictions_cid"
                            checked={this.state.sipnavFormData.disable_call_restrictions_cid || false}
                            onChange={(e) => this.setState({
                              sipnavFormData: { ...this.state.sipnavFormData, disable_call_restrictions_cid: e.target.checked }
                            })}
                          />
                          <label className="custom-control-label" htmlFor="disable_call_restrictions_cid">CID</label>
                        </div>
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="disable_call_restrictions_destination"
                            checked={this.state.sipnavFormData.disable_call_restrictions_destination || false}
                            onChange={(e) => this.setState({
                              sipnavFormData: { ...this.state.sipnavFormData, disable_call_restrictions_destination: e.target.checked }
                            })}
                          />
                          <label className="custom-control-label" htmlFor="disable_call_restrictions_destination">Destination</label>
                        </div>
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="disable_call_restrictions_ani"
                            checked={this.state.sipnavFormData.disable_call_restrictions_ani || false}
                            onChange={(e) => this.setState({
                              sipnavFormData: { ...this.state.sipnavFormData, disable_call_restrictions_ani: e.target.checked }
                            })}
                          />
                          <label className="custom-control-label" htmlFor="disable_call_restrictions_ani">ANI</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label style={{ color: "#364a63", fontWeight: 500, display: "block", marginBottom: 8 }}>
                        ANI Blacklist
                      </label>
                      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", border: "1px solid #e5e9f2", borderRadius: 6, padding: "10px 14px" }}>
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="ani_blacklist_global"
                            checked={this.state.sipnavFormData.ani_blacklist_global || false}
                            onChange={(e) => this.setState({
                              sipnavFormData: { ...this.state.sipnavFormData, ani_blacklist_global: e.target.checked }
                            })}
                          />
                          <label className="custom-control-label" htmlFor="ani_blacklist_global">Global</label>
                        </div>
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="ani_blacklist_custom"
                            checked={this.state.sipnavFormData.ani_blacklist_custom || false}
                            onChange={(e) => this.setState({
                              sipnavFormData: { ...this.state.sipnavFormData, ani_blacklist_custom: e.target.checked }
                            })}
                          />
                          <label className="custom-control-label" htmlFor="ani_blacklist_custom">Custom</label>
                        </div>
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="ani_blacklist_none"
                            checked={this.state.sipnavFormData.ani_blacklist_none || false}
                            onChange={(e) => this.setState({
                              sipnavFormData: { ...this.state.sipnavFormData, ani_blacklist_none: e.target.checked }
                            })}
                          />
                          <label className="custom-control-label" htmlFor="ani_blacklist_none">None</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* IP Addresses Header */}
                <div style={{ 
                  marginTop: 24,
                  marginBottom: 16, 
                  paddingBottom: 8, 
                  borderBottom: "1px solid #e5e9f2" 
                }}>
                  <div style={{ color: "#364a63", fontWeight: 600, fontSize: "0.9rem" }}>
                    IP Addresses
                  </div>
                </div>

                {/* Account IPs */}
                <div className="form-group">
                  <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 10 }}>
                    <div>
                      <div style={{ color: "#364a63", fontWeight: 500, fontSize: "0.875rem" }}>
                        Account IPs (Remediation Trunks)
                      </div>
                      <small style={{ color: "#8094ae" }}>
                        VoiceAlerts IP addresses shown to clients
                      </small>
                    </div>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => this.addIP("account_ips")}
                    >
                      <em className="icon ni ni-plus"></em> Add IP
                    </button>
                  </div>
                  {this.state.sipnavFormData.account_ips.map((ip, index) => (
                    <div key={index} className="input-group mb-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="e.g., 88.151.129.48"
                        value={ip}
                        onChange={(e) => this.handleIPChange("account_ips", index, e.target.value)}
                      />
                      <div className="input-group-append">
                        <button
                          className="btn btn-outline-danger"
                          type="button"
                          onClick={() => this.removeIP("account_ips", index)}
                          title="Remove IP"
                        >
                          <em className="icon ni ni-cross"></em>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Carrier IPs */}
                <div className="form-group mt-4">
                  <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: 10 }}>
                    <div>
                      <div style={{ color: "#364a63", fontWeight: 500, fontSize: "0.875rem" }}>
                        Carrier IPs (Origination/Termination Trunks)
                      </div>
                      <small style={{ color: "#8094ae" }}>
                        SIPNav Account IPs shown to clients
                      </small>
                    </div>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => this.addIP("carrier_ips")}
                    >
                      <em className="icon ni ni-plus"></em> Add IP
                    </button>
                  </div>
                  {this.state.sipnavFormData.carrier_ips.map((ip, index) => (
                    <div key={index} className="input-group mb-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="e.g., 88.151.131.47"
                        value={ip}
                        onChange={(e) => this.handleIPChange("carrier_ips", index, e.target.value)}
                      />
                      <div className="input-group-append">
                        <button
                          className="btn btn-outline-danger"
                          type="button"
                          onClick={() => this.removeIP("carrier_ips", index)}
                          title="Remove IP"
                        >
                          <em className="icon ni ni-cross"></em>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Modal Footer */}
              <div className="modal-footer" style={{ borderTop: "1px solid #e5e9f2", padding: "12px 20px", gap: 10, justifyContent: "flex-end" }}>
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={this.closeSipnavConfigModal}
                  disabled={this.state.sipnavModalLoading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={this.handleSaveSipnavConfig}
                  disabled={this.state.sipnavModalLoading}
                >
                  {this.state.sipnavModalLoading ? (
                    <span>
                      <span className="spinner-border spinner-border-sm mr-2" />
                      Saving...
                    </span>
                  ) : (
                    <span>
                      <em className="icon ni ni-check mr-1"></em>
                      Save Configuration
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Backdrop */}
      {(this.state.showAddModal || this.state.showEditModal || this.state.showViewModal || this.state.showSipnavModal) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </>
    );
  }
}

export default PendingApproval;
